import { useCallback } from 'react'
import nrLogger from '../../../../../../../helpers/nrLogger'
import shoppingCartV2Api from '../../../../../api'

const useSendEmail = params => {
  const {
    setIsProcessing,
    setIsFormSubmitted,
    getInvalidFields,
    setError,
    outOfStockItems,
    email,
    captcha,
    setIsSent,
  } = params

  return useCallback(
    async () => {
      const invalidFields = getInvalidFields()
      if (invalidFields) {
        setError(invalidFields)
        return
      }

      setIsProcessing(true)
      const promises = outOfStockItems
        .map(
          item => shoppingCartV2Api.emails
            .notifyOutOfStock(
              email,
              captcha,
              item.product.productId,
            )
            .catch(error => error),
        )

      try {
        const res = await Promise.all(promises)
        const notSentEmails = res.filter(
          currentRes => {
            if (
              (currentRes instanceof Error) ||
              (
                currentRes?.results &&
                currentRes?.results?.data &&
                !currentRes?.results?.data?.success
              )
            ) return true
            return false
          },
        )
        if (notSentEmails.length) {
          throw new Error('Request Failed.')
        }

        setIsSent(true)
      } catch (error) {
        nrLogger.error('ShoppingCartV2.NotifyForm.useSendEmail.error', error)
        setIsSent(false)
      }
      setIsProcessing(false)
      setIsFormSubmitted(true)
    },
    [
      setIsProcessing,
      setIsFormSubmitted,
      getInvalidFields,
      setError,
      outOfStockItems,
      email,
      captcha,
      setIsSent,
    ],
  )
}

export default useSendEmail
